const SW_PATH = '/sw-push.js'

let swRegistration: ServiceWorkerRegistration | null = null

export async function registerPushServiceWorker(): Promise<ServiceWorkerRegistration> {
  if (swRegistration) return swRegistration

  if (!('serviceWorker' in navigator)) {
    throw new Error('Service workers are not supported')
  }

  swRegistration = await navigator.serviceWorker.register(SW_PATH, {
    scope: '/',
  })

  await navigator.serviceWorker.ready
  return swRegistration
}

export async function showLocalNotification(
  title: string,
  options?: NotificationOptions,
): Promise<void> {
  const registration = await registerPushServiceWorker()
  await registration.showNotification(title, {
    icon: '/bitslegacy_logo.png',
    badge: '/bitslegacy_logo.png',
    ...options,
  })
}

export async function getPushSubscription(
  vapidPublicKey: string,
): Promise<PushSubscription | null> {
  const registration = await registerPushServiceWorker()

  const existing = await registration.pushManager.getSubscription()
  if (existing) return existing

  const applicationServerKey = urlBase64ToUint8Array(vapidPublicKey)
  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: applicationServerKey as unknown as BufferSource,
  })
}

export async function unsubscribePush(): Promise<boolean> {
  const registration = await registerPushServiceWorker()
  const subscription = await registration.pushManager.getSubscription()
  if (!subscription) return true
  return subscription.unsubscribe()
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}
